import {AbstractControl, ValidatorFn} from '@angular/forms';

import {NameValidatorKey} from './custom-validator-keys';

export function NameValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = control.value;

        if (!controlValue) {
            return null;
        }

        return !/^[a-zA-Z\s\-']+$/.test(controlValue) ? {[NameValidatorKey]: true} : null;
    };
}
